import { addressLabel } from "./addressLabel";

/**
 * Display text for an Address object, "N/A" when there's nothing to show.
 * Some legacy shapes carry a single `street` line instead of
 * streetNumber/streetName — assemble from that when present, otherwise
 * delegate to `addressLabel` (fullAddress → parts → displayAddress).
 */
export const formatAddressObject = (address) => {
  if (!address) return "N/A";

  const full = address.fullAddress;
  if (typeof full === "string" && full.trim()) return full;

  if (address.street) {
    const { street, city, state, zip } = address;
    return [street, city, [state, zip].filter(Boolean).join(" ")]
      .filter(Boolean)
      .join(", ")
      .trim();
  }

  return addressLabel(address, "N/A");
};
